import { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted/declined cookies
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Small delay for smoother UX
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom-5 duration-500"
      data-testid="cookie-consent"
    >
      <div className="max-w-4xl mx-auto">
        <div className="bg-brand-navy rounded-lg shadow-2xl border border-white/10 p-4 sm:p-5">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            {/* Icon & Text */}
            <div className="flex items-start gap-3 flex-1">
              <div className="w-10 h-10 bg-brand-orange/20 rounded-full flex items-center justify-center flex-shrink-0">
                <Cookie className="w-5 h-5 text-brand-orange" />
              </div>
              <div>
                <p className="text-white text-sm sm:text-base leading-relaxed">
                  We use cookies to enhance your browsing experience and analyze site traffic.
                  {" "}
                  <Link 
                    to="/privacy" 
                    className="text-brand-orange hover:underline"
                  >
                    Learn more
                  </Link>
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-2 w-full sm:w-auto">
              <Button
                onClick={handleDecline}
                variant="ghost"
                size="sm"
                className="text-white/70 hover:text-white hover:bg-white/10 font-medium text-sm flex-1 sm:flex-none"
              >
                Decline
              </Button>
              <Button
                onClick={handleAccept}
                size="sm"
                className="bg-brand-orange hover:bg-brand-orange/90 text-white font-semibold text-sm px-6 flex-1 sm:flex-none"
              >
                Accept
              </Button>
            </div>

            {/* Close button (mobile) */}
            <button
              onClick={handleDecline}
              className="absolute top-3 right-3 sm:hidden text-white/50 hover:text-white"
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
